"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Controls = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ToggleGroup = require("../ToggleGroup");
var _Icons = require("../Icons");
var _Search = require("../Search");
var _ControlsModule = _interopRequireDefault(require("./Controls.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var VIEW_OPTIONS = [{
  key: 'list',
  icon: /*#__PURE__*/_react.default.createElement(_Icons.IconRows3, {
    isFilled: true
  })
}, {
  key: 'grid',
  icon: /*#__PURE__*/_react.default.createElement(_Icons.IconGrid1, {
    isFilled: true
  })
}];
var Controls = _ref => {
  var canSwitchViews = _ref.canSwitchViews,
    onSwitchViews = _ref.onSwitchViews,
    isGridView = _ref.isGridView,
    onChangeSearchQuery = _ref.onChangeSearchQuery,
    searchPlaceholder = _ref.searchPlaceholder,
    searchQuery = _ref.searchQuery,
    isSearchable = _ref.isSearchable;
  var ViewToggle = (0, _react.useMemo)(() => () => {
    if (!canSwitchViews) return null;
    return /*#__PURE__*/_react.default.createElement(_ToggleGroup.ToggleGroup, {
      className: _ControlsModule.default.Toggle,
      selection: isGridView ? 'grid' : 'list',
      selectionType: 'single',
      onSelectionChange: key => {
        onSwitchViews === null || onSwitchViews === void 0 || onSwitchViews(key === 'grid');
      },
      options: VIEW_OPTIONS,
      variant: 'minimal',
      isRequired: true
    });
  }, [canSwitchViews, onSwitchViews, isGridView]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _ControlsModule.default.Container
  }, isSearchable && /*#__PURE__*/_react.default.createElement(_Search.Search, {
    className: _ControlsModule.default.Search,
    placeholder: searchPlaceholder,
    queryString: searchQuery,
    onQueryStringChange: onChangeSearchQuery
  }), /*#__PURE__*/_react.default.createElement(ViewToggle, null));
};
exports.Controls = Controls;
//# sourceMappingURL=Controls.js.map